import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../views/ai-assistant/Index.vue')
const WorkPlan = () => import('../views/ai-assistant/WorkPlan.vue')
const LessonPlan = () => import('../views/ai-assistant/LessonPlan.vue')
const TeachingPlan = () => import('../views/ai-assistant/TeachingPlan.vue')
const StudentComment = () => import('../views/ai-assistant/StudentComment.vue')
const SemesterSummary = () => import('../views/ai-assistant/SemesterSummary.vue')
const TeachingPlanEdit = () => import('../views/ai-assistant/TeachingPlanEdit.vue')

const indexRoute: RouteConfig = {
  path: '/ai-assistant',
  name: 'ai_assistant',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI助手',
    ignoreLogin: true,
  },
}

const workPlanRoute: RouteConfig = {
  path: '/ai-assistant/work-plan',
  name: 'ai_assistant_work_plan',
  component: WorkPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '工作计划',
  },
}

const lessonPlanRoute: RouteConfig = {
  path: '/ai-assistant/lesson-plan',
  name: 'ai_assistant_lesson_plan',
  component: LessonPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '教学教案',
  },
}

const teachingPlanRoute: RouteConfig = {
  path: '/ai-assistant/teaching-plan',
  name: 'ai_assistant_teaching_plan',
  component: TeachingPlan,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '教学计划',
  },
}

const studentCommentRoute: RouteConfig = {
  path: '/ai-assistant/student-comment',
  name: 'ai_assistant_student_comment',
  component: StudentComment,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学生评语',
  },
}

const semesterSummaryRoute: RouteConfig = {
  path: '/ai-assistant/semester-summary',
  name: 'ai_assistant_semester_summary',
  component: SemesterSummary,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '期末总结',
  },
}

const teachingPlanEditRoute: RouteConfig = {
  path: '/ai-assistant/teaching-plan-edit',
  name: 'ai_assistant_teaching_plan_edit',
  component: TeachingPlanEdit,
  props: (route) => ({
    ...route.query,
    ...route.params,
    initialized: 'initialized' in route.query && route.query.initialized !== undefined,
  }),
  meta: {
    title: '教学计划',
  },
}

export default [
  indexRoute,
  workPlanRoute,
  lessonPlanRoute,
  teachingPlanRoute,
  studentCommentRoute,
  semesterSummaryRoute,
  teachingPlanEditRoute,
]

export function navigateToAIAssistant(router: VueRouter) {
  router.push({ name: indexRoute.name })
}

export function navigateToAIAssistantWorkPlan(router: VueRouter) {
  router.push({ name: workPlanRoute.name })
}

export function navigateToAIAssistantLessonPlan(router: VueRouter, id: string, course: string) {
  router.push({ name: lessonPlanRoute.name, query: { id, course } })
}

export function navigateToAIAssistantTeachingPlan(router: VueRouter) {
  router.push({ name: teachingPlanRoute.name })
}

export function navigateToAIAssistantStudentComment(router: VueRouter) {
  router.push({ name: studentCommentRoute.name })
}

export function navigateToAIAssistantSemesterSummary(router: VueRouter) {
  router.push({ name: semesterSummaryRoute.name })
}

export function navigateToAIAssistantTeachingPlanEdit(router: VueRouter) {
  router.push({ name: teachingPlanEditRoute.name })
}
